<template>
  <div
    v-if="item.type === 'text'"
    :id="item.id"
    :ref="'element' + item.id"
    class="element"
    :style="item.style"
    @touchstart="touchstart"
    @touchmove="touchmove"
    @touchend="touchend"
    @click="click"
  >
    {{ item.value }}
  </div>
  <img
    v-else
    :id="item.id"
    :ref="'element' + item.id"
    class="element"
    :style="item.style"
    :src="item.base64 || item.value"
    alt=""
    @touchstart="touchstart"
    @touchmove="touchmove"
    @touchend="touchend"
    @click="click"
  >

</template>

<script>
import _ from 'lodash'

export default {
  name: 'Element',
  props: {
    item: {
      type: Object,
      default() {
        return {
          id: '',
          type: '',
          style: {},
          value: {}
        }
      }
    }
  },
  data() {
    return {
      offsetTop: undefined,
      offsetLeft: undefined,
      clientX: undefined,
      clientY: undefined
    }
  },
  watch: {
    'item.value'(newVal) {
      if (this.item.type === 'text') {
        // console.log('1231231', newVal)
        this.$nextTick(() => {
          const node = document.querySelector(`#${this.item.id}`)
          const width = node.offsetWidth + 'px'
          const height = node.offsetHeight + 'px'
          this.$emit('changeStyle', {
            id: this.item.id,
            style: {
              width,
              minHeight: height
            }
          })
        })
      }
    }
  },
  mounted() {
  },
  methods: {
    touchstart(e) {
      console.log('mehtods touchstart')
      if (!this.item.isEdit) return
      const { targetTouches } = e
      const { target, clientX, clientY } = targetTouches[0]
      this.offsetTop = target.offsetTop
      this.offsetLeft = target.offsetLeft
      this.clientX = clientX
      this.clientY = clientY
      console.log(clientX, clientY)
      this.$emit('changeCurrent', this.item.id)
    },
    touchmove: _.throttle(function(e) {
      if (!this.item.isEdit) return
      const { targetTouches } = e
      const { clientX, clientY } = targetTouches[0]
      this.$emit('changeStyle', {
        style: {
          top: clientY - this.clientY + this.offsetTop + 'px',
          left: clientX - this.clientX + this.offsetLeft + 'px'
        },
        id: this.item.id
      })

      // this.$emit('changeBorderStyle', {
      //   style: {
      //     top: clientY - this.clientY + this.offsetTop + 'px',
      //     left: clientX - this.clientX + this.offsetLeft + 'px'
      //   },
      //   isMoving: true
      // })
    }, 0),
    touchend(e) {
      // console.log('touchend e:', e)
      // const { target } = e
      // this.offsetTop = target.offsetTop
      // this.offsetLeft = target.offsetLeft
      // this.clientX = clientX
      // this.clientY = clientY
    },
    click() {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.element {
  position: absolute;
  .img{
    position: relative;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
}
</style>
